<template>
  <div>
    <div class="contents course-info">
      <p class="course-name border-top-dgray border-bottom-gray fs-lg-18 lh-sm">
        {{ coursebasicinfo.coursename }}
      </p>

      <div class="row g-0 border-bottom-gray">
        <div class="col-md-6 d-flex position-relative">
          <img :src="coursebasicinfo.course_image_url | get_img" />
        </div>

        <div class="col-md-6 d-flex flex-column border-top border-md-0">
          <div class="row g-0 border-bottom h-100">
            <div class="col bg-gray d-flex justify-content-center">
              <label class="d-table-cell align-self-center mb-0">{{
                $t("title.common.code")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ coursebasicinfo.coursecode }}
              </p>
            </div>
          </div>

          <div class="row g-0 border-bottom h-100">
            <div class="col bg-gray d-flex justify-content-center">
              <label class="d-table-cell align-self-center mb-0">{{
                $t("title.golfcourse.golfcourse_difficulty")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                <i
                  class="material-icons"
                  :class="
                    coursebasicinfo.field >= index
                      ? 'text-yellow'
                      : 'text-lightgray'
                  "
                  v-for="index in 5"
                  :key="index"
                  >star</i
                >
              </p>
            </div>
          </div>

          <div class="row g-0 border-bottom h-100">
            <div class="col bg-gray d-flex justify-content-center">
              <label class="d-table-cell align-self-center mb-0">{{
                $t("title.golfcourse.green_difficulty")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                <i
                  class="material-icons"
                  :class="
                    coursebasicinfo.green >= index
                      ? 'text-green'
                      : 'text-lightgray'
                  "
                  v-for="index in 5"
                  :key="index"
                  >flag</i
                >
              </p>
            </div>
          </div>
          <div class="row g-0 border-bottom h-100">
            <div class="col bg-gray d-flex justify-content-center">
              <label class="d-table-cell align-self-center mb-0"
                >{{ $t("title.common.hole") }} /
                {{ $t("title.golfcourse.par_count") }}</label
              >
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ coursebasicinfo.holesum }}H / {{ coursebasicinfo.parsum }}PAR
              </p>
            </div>
          </div>

          <div class="row g-0 h-100">
            <div class="col bg-gray d-flex justify-content-center">
              <label class="d-table-cell align-self-center">{{
                $t("title.golfcourse.distance")
              }}</label>
            </div>
            <div class="col d-flex">
              <p class="d-table-cell align-self-center">
                {{ coursebasicinfo.distance | comma }}m
              </p>
            </div>
          </div>
        </div>
      </div>

      <p class="mt-3 text-subscript fs-14 text-orange">
        <span class="material-icons-outlined me-1">info</span
        >{{ $t("text.golfcourse.title_information") }}
      </p>

      <!-- Sub Course -->
      <div
        v-for="(anc, index) in subcourse"
        :key="index"
        class="course-details"
      >
        <p class="info">
          {{ $t("title.golfcourse.sub_course") }} {{ anc.subcourseseq }} [{{
            anc.title
          }}]
        </p>
        <div class="position-relative">
          <table class="table scorecard_title">
            <thead>
              <tr class="bg-gray">
                <th class="align-middle">{{ $t("title.common.hole") }}</th>
              </tr>
              <tr class="bg-gray">
                <th class="align-middle">{{ $t("title.common.par") }}</th>
              </tr>
              <tr class="bg-gray">
                <th class="border-bottom-0 align-middle">
                  {{ $t("title.common.handicap") }}
                </th>
              </tr>
            </thead>
          </table>
          <div class="courselist view list" v-if="anc.subcoursehole.length > 0">
            <div class="fix-table">
              <table class="table">
                <tbody>
                  <tr>
                    <td
                      v-for="(inc, index) in anc.subcoursehole"
                      :key="index"
                      @click="showModal(inc.hole_no, anc.subcourseseq)"
                      class="position-relative"
                    >
                      <span class="rounded-circle info-hole">
                        {{ inc.hole_no }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      v-for="(inc, index) in anc.subcoursehole"
                      :key="index"
                      @click="showModal(inc.hole_no, anc.subcourseseq)"
                    >
                      <span class="rounded-circle info-par">
                        {{ inc.par_score }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      v-for="(inc, index) in anc.subcoursehole"
                      :key="index"
                    >
                      {{ inc.handicap }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="$router.push({ name: 'CourseList' })"
          >{{ $t("button.common.list") }}</b-button
        >
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.edit')"
          type="submit"
          @click="
            $router.push({ name: 'CourseEdit', params: { courseno: courseno } })
          "
          >{{ $t("button.common.edit") }}</b-button
        >
      </div>
    </div>

    <b-modal
      id="modal-hole-info"
      ref="modal-hole-info"
      size="xl"
      centered
      scrollable
      hide-footer
    >
      <template #modal-header>
        <h5 class="modal-title">
          <p>
            {{ $t("title.golfcourse.sub_course") }}
            {{ hole_model.coursubtype }} [{{ hole_model.description }}]
          </p>
          <!-- ({{ hole_model.subcoursename }}) -->
          <div class="hole-details mt-2">
            <span>{{ $t("title.common.hole") }} {{ hole_model.hole }}</span>
            <span>{{ $t("title.common.par") }} {{ hole_model.par }}</span>
            <span
              >{{ $t("title.common.handicap") }} {{ hole_model.handicap }}</span
            >
          </div>
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-hole-info'].hide()"
        ></b-button>
      </template>

      <div class="minimap row g-4" v-if="hole_model.minimap_name">
        <div class="col">
          <div class="card h-100">
            <h6 class="p-3 fs-6 fs-lg-18 border-bottom">
              {{ $t("title.golfcourse.golfcourse_minimap") }}
            </h6>
            <div class="card-body">
              <img
                :src="
                  (hole_model.minimap_url + '/' + hole_model.minimap_name)
                    | get_img
                "
              />
              <!-- <img
                src="https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/course/$1012/$1012_00H.png"
              /> -->
            </div>
          </div>
        </div>

        <!-- <template v-if="hole_model.greenmapl != null"> -->
        <div class="col" v-if="hole_model.grnmap1_name">
          <div class="card h-100">
            <h6 class="p-3 fs-6 fs-lg-18 border-bottom">
              {{ $t("title.golfcourse.green_minimap_left") }}
            </h6>
            <div class="card-body">
              <img
                :src="
                  (hole_model.grnmap1_url + '/' + hole_model.grnmap1_name)
                    | get_img
                "
              />
              <!-- <img
                src="https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/course/$1012/$1012_00H_GRN_L.png"
              /> -->
            </div>
          </div>
        </div>
        <!-- </template> -->

        <!-- <template v-if="hole_model.greenmapr != null"> -->
        <div class="col" v-if="hole_model.grnmap2_name">
          <div class="card h-100">
            <h6 class="p-3 fs-6 fs-lg-18 border-bottom">
              {{ $t("title.golfcourse.green_minimap_right") }}
            </h6>
            <div class="card-body">
              <img
                :src="
                  (hole_model.grnmap2_url + '/' + hole_model.grnmap2_name)
                    | get_img
                "
              />
              <!-- <img
                src="https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/course/$1012/$1012_00H_GRN_R.png"
              /> -->
            </div>
          </div>
        </div>
        <!-- </template> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/course";
import "@/filter/common";

export default {
  name: "CourseView",
  data() {
    return {
      courseno: this.$route.params.courseno || "",
      coursebasicinfo: [
        {
          area: "",
          coursename: "",
          path: "",
          image: "",
          field: "",
          green: "",
          holesum: "",
          parsum: "",
          distance: "",
          coursecode: "",
          handicap: "",
        },
      ],
      subcoursecnt: "",
      subcourse: [
        {
          subcourseseq: "",
          subcourseno: "",
          title: "",
          subcoursehole: [],
        },
      ],
      hole_model: {
        hole: "",
        coursubtype: "",
        title: "",
        par: "",
        minimap_name: "",
        grnmap1_name: "",
        grnmap2_name: "",
        movie_name: "",
        minimap_url: "",
        grnmap1_url: "",
        grnmap2_url: "",
        movie_url: "",
        description: "",
      },
      scroll: "r",
      hold: false,
      inter_clear: Object,
      scroll2: "r",
      hold2: false,
      inter_clear2: Object,
    };
  },
  methods: {
    get_courseview() {
      ax.get_admincourseview(this.courseno, (flag, data) => {
        if (flag) {
          this.coursebasicinfo = data.coursebasicinfo;
          this.subcourse = data.subcourse || [];
          this.subcoursecnt = this.subcourse.length;
        } else {
          alert(data);
        }
      });
    },
    showModal(hole, type) {
      ax.get_admincourseholeview(this.courseno, hole, type, (flag, data) => {
        if (flag) {
          this.hole_model.hole = hole;
          this.hole_model.coursubtype = type;
          this.hole_model.subcoursename = data.courseholeview.subcoursename;
          this.hole_model.par = data.courseholeview.par;
          this.hole_model.minimap_url = data.courseholeview.minimap_url;
          this.hole_model.minimap_name = data.courseholeview.minimap_name;
          this.hole_model.grnmap1_url = data.courseholeview.grnmap1_url;
          this.hole_model.grnmap1_name = data.courseholeview.grnmap1_name;
          this.hole_model.grnmap2_name = data.courseholeview.grnmap2_name;
          this.hole_model.movie_url = data.courseholeview.movie_url;
          this.hole_model.movie_name = data.courseholeview.movie_name;
          this.hole_model.handicap = data.courseholeview.handicap;
          this.hole_model.description = data.courseholeview.description;
          //this.$refs["modal-hole-info"].modalOuterStyle.zIndex = 9999;
          this.$refs["modal-hole-info"].show();
        } else {
          alert(data.message);
        }
      });
    },
    hideModal() {
      this.$refs["modal-hole-info"].hide();
    },

    scroll_x() {
      let content = document.querySelector(".subcourse");
      let scrollAmount = 0;
      if (this.scroll === "r") {
        scrollAmount = 0;
        let slideTimer = setInterval(function () {
          content.scrollLeft += 40;
          scrollAmount += 40;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);
      } else {
        scrollAmount = 0;
        let slideTimer = setInterval(function () {
          content.scrollLeft -= 40;
          scrollAmount += 40;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);
      }
    },
    scroll_x2() {
      let content = document.querySelector(".subcoursehole");
      let scrollAmount = 0;
      if (this.scroll2 === "r") {
        //content.scrollLeft += 40
        scrollAmount = 0;
        let slideTimer = setInterval(function () {
          content.scrollLeft += 40;
          scrollAmount += 40;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);
      } else {
        //content.scrollLeft -= 40
        scrollAmount = 0;
        let slideTimer = setInterval(function () {
          content.scrollLeft -= 40;
          scrollAmount += 40;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);
      }
    },
    course_click(course, direction) {
      let scrollAmount = 0;
      let content = "";
      if (course === "in") {
        content = document.querySelector(".subcoursehole");
      } else if (course === "out") {
        content = document.querySelector(".subcoursehole");
      }
      if (direction === "r") {
        scrollAmount = 0;
        let slideTimer = setInterval(function () {
          content.scrollLeft += 40;
          scrollAmount += 40;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);
      } else {
        scrollAmount = 0;
        let slideTimer = setInterval(function () {
          content.scrollLeft -= 40;
          scrollAmount += 40;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);
      }
    },
  },
  watch: {
    hold: function () {
      if (this.hold) {
        this.inter_clear = setInterval(this.scroll_x, 1000);
      } else {
        clearInterval(this.inter_clear);
      }
    },
    hold2: function () {
      if (this.hold2) {
        this.inter_clear2 = setInterval(this.scroll_x2, 1000);
      } else {
        clearInterval(this.inter_clear2);
      }
    },
  },
  mounted() {
    this.get_courseview();
  },
};
</script>